module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "border-medium radius-normal mb-3 bg-lighter"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-end px-3 py-2 border-bottom-light"
  }, [_c('div', {
    staticClass: "font-weight-600 darker py-2 col-sm-6"
  }, [_c('div', {
    staticClass: "row flexGrow1"
  }, [(_vm.widget.editing) ? _c('span', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "w-100"
  }, [_c('label', {
    staticClass: "pb-1"
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widget.name),
      expression: "widget.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "Widget Name"
    },
    domProps: {
      "value": (_vm.widget.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widget, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "d-flex my-3"
  }, [_c('div', {
    staticClass: "mr-3 w-50"
  }, [_c('label', [_vm._v("Google Tag Manager ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widget.gtagId),
      expression: "widget.gtagId"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "GTM-XXXXXXX"
    },
    domProps: {
      "value": (_vm.widget.gtagId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widget, "gtagId", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "w-50"
  }, [_c('label', [_vm._v("Google Analytics Measurement ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widget.googleAnalyticsMeasurementId),
      expression: "widget.googleAnalyticsMeasurementId"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "G-XXXXXXX"
    },
    domProps: {
      "value": (_vm.widget.googleAnalyticsMeasurementId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widget, "googleAnalyticsMeasurementId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "my-3",
    class: {
      error: _vm.$v.widget.email.$error
    }
  }, [_c('label', {
    staticClass: "w-100"
  }, [_c('span', [_vm._v("Email - Booking notifications")]), _vm._v(" "), _c('span', {
    staticClass: "normal fs-smaller"
  }, [_vm._v("(you can enter multiple emails by separating them with comma \",\")")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.widget.email),
      expression: "widget.email"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text",
      "placeholder": "email1@domain.com, email2@domain.com, email3@domain.com"
    },
    domProps: {
      "value": (_vm.widget.email)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.widget, "email", $event.target.value)
      }, _vm.$v.widget.email.$touch]
    }
  })]), _vm._v(" "), (_vm.$v.widget.email.$error) ? _c('div', {
    staticClass: "messages"
  }, [(!_vm.$v.widget.email.isEmailValid) ? _c('span', [_vm._v("Invalid email.")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 px-0 d-flex"
  }, [_c('div', {
    staticClass: "d-flex align-items-center py-2 pl-0 mt-3 pr-4"
  }, [_c('checkbox', {
    model: {
      value: (_vm.widget.isToSkipMyCart),
      callback: function($$v) {
        _vm.$set(_vm.widget, "isToSkipMyCart", $$v)
      },
      expression: "widget.isToSkipMyCart"
    }
  }), _vm._v("\n                            Hide \"My Cart\" step.\n                        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center py-2 pl-0 mt-3"
  }, [_c('checkbox', {
    model: {
      value: (_vm.widget.isToHidePromocode),
      callback: function($$v) {
        _vm.$set(_vm.widget, "isToHidePromocode", $$v)
      },
      expression: "widget.isToHidePromocode"
    }
  }), _vm._v("\n                            Hide Promocode.\n                        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "border-bottom mb-3 pb-1"
  }, [_vm._v("Widget for a specific date:")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-sm-12 mr-3 d-inline-flex pb-1"
  }, [_vm._v("Choose the date")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('DatePickerNew', {
    staticClass: "datepicker-align-left",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.singularEventDate),
      callback: function($$v) {
        _vm.singularEventDate = $$v
      },
      expression: "singularEventDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 pl-0 d-flex align-items-center",
    on: {
      "click": _vm.removeWidgetDate
    }
  }, [_c('i', {
    staticClass: "pointer ico ico-delete fs-smaller"
  })]), _vm._v(" "), (_vm.widget.singularEventDate != null && _vm.widget.singularEventDate != '') ? _c('div', {
    staticClass: "col-sm-7 d-flex align-items-center"
  }, [_c('checkbox', {
    model: {
      value: (_vm.widget.isToHideDate),
      callback: function($$v) {
        _vm.$set(_vm.widget, "isToHideDate", $$v)
      },
      expression: "widget.isToHideDate"
    }
  }), _vm._v("Hide it on widget?\n                            ")], 1) : _vm._e()])])]) : _c('span', [_vm._v(_vm._s(_vm.widget.name))])])]), _vm._v(" "), (_vm.widget.loading) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.widget.loading) ? _c('div', {
    staticClass: "my-2"
  }, [(_vm.isCreatingWidget == false) ? _c('div', {
    staticClass: "d-flex"
  }, [(_vm.widget.editing) ? _c('button', {
    staticClass: "btn custom-widget save-btn font-weight-400 bg-color-3 lighter fs-smaller radius-normal pointer mr-2",
    class: {
      'opacity-50 notAllowed': _vm.noProductsSelected
    },
    attrs: {
      "disabled": _vm.noProductsSelected
    },
    on: {
      "click": function($event) {
        return _vm.saveEditedWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-check fs-smaller"
  }), _vm._v("Save")]) : _vm._e(), _vm._v(" "), (_vm.widget.editing) ? _c('button', {
    staticClass: "btn custom-widget font-weight-400 bg-dark lighter fs-smaller radius-normal pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.cancelEditedWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-close fs-smaller"
  }), _vm._v("Cancel")]) : _vm._e(), _vm._v(" "), (!_vm.widget.editing) ? _c('button', {
    staticClass: "btn custom-widget font-weight-400 bg-dark lighter fs-smaller radius-normal pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.activateEditionMode(_vm.widget)
      }
    }
  }, [(_vm.widget.isLoading) ? _c('div', [_c('span', [_vm._v("Loading")])]) : _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    staticClass: "ico ico-edit fs-smaller"
  }), _vm._v(" "), _c('span', [_vm._v("Edit")])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn custom-widget delete-btn font-weight-400 bg-color-6 lightest fs-smaller radius-normal pointer",
    on: {
      "click": function($event) {
        return _vm.deletThisWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-delete fs-smaller"
  }), _vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (_vm.isCreatingWidget == true) ? _c('div', [_c('button', {
    staticClass: "btn custom-widget bg-color-3 lighter fs-smaller radius-normal pointer mr-2",
    class: {
      'opacity-50 notAllowed': _vm.validation.$invalid
    },
    on: {
      "click": function($event) {
        return _vm.creatingSaveWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-check fs-smaller"
  }), _vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn custom-widget bg-dark lighter fs-smaller radius-normal pointer mr-2",
    on: {
      "click": function($event) {
        return _vm.creatingWidgetCancelWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-close fs-smaller"
  }), _vm._v("Cancel")])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.widget.editing && _vm.widget.categoryProductList) ? _c('div', {
    staticClass: "px-3 py-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('checkbox', {
    model: {
      value: (_vm.widget.isToActiveFutureItems),
      callback: function($$v) {
        _vm.$set(_vm.widget, "isToActiveFutureItems", $$v)
      },
      expression: "widget.isToActiveFutureItems"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Allow new Products/Categories added to inventory to be automatically available in this widget.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "error error-min-height"
  }, [(_vm.productsSelectedError) ? _c('span', [_vm._v("\n                Choose at least one product to save the changes.\n            ")]) : _vm._e()]), _vm._v(" "), _c('widget-composer', {
    attrs: {
      "productOptions": _vm.productsArr,
      "showInputName": false
    },
    model: {
      value: (_vm.widget),
      callback: function($$v) {
        _vm.widget = $$v
      },
      expression: "widget"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isCreatingWidget == false) ? _c('div', [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "border-dark radius-normal bg-lightest m-3 p-2"
  }, [_c('div', {
    staticClass: "fs-small position-relative"
  }, [_vm._v("\n                " + _vm._s(_vm.generateIframeCode(_vm.widget.guid)) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [_c('button', {
    staticClass: "copy-btn dark border-dark radius-normal align-items-center px-2 py-1 pointer bg-lightest fs-smaller",
    on: {
      "click": function($event) {
        return _vm.copyWidget(_vm.widget)
      }
    }
  }, [_c('i', {
    staticClass: "ico ico-notes fs-smaller"
  }), _vm._v("\n                    Copy\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "m-3 d-flex justify-content-end align-items-center"
  }, [_c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Costumize the widget to better fit in your website'),
      expression: "'Costumize the widget to better fit in your website'"
    }],
    staticClass: "btn preview-btn font-weight-600 bg-color-1 lightest fs-smaller radius-normal pointer",
    on: {
      "click": function($event) {
        return _vm.costumizeWidget()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-eye fs-smaller"
  }), _vm._v("Preview and Costumize\n            ")])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-grow-1 my-3"
  }, [_c('h3', [_vm._v("Select items")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fs-small font-weight-600 dark d-flex align-items-center justify-content-between px-3 pt-3"
  }, [_c('div', [_c('span', [_vm._v("This is the default code, you can costumize it to fit your website by pressing the \"Preview and Costumize\" button:")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-63ff5b85", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63ff5b85"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/widget/widgetEditor.vue
// module id = 2526
// module chunks = 0